module.exports = __webpack_public_path__ + "static/media/march-pdf.208aab43.jpg";